<template>
  <div class="app flex-row align-items-center bg-white">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="12">
          <b-card-group>
            
            <b-card no-body class="text-white" style="border: none;">
              <b-card-body class="text-center">
                <div>
                  <img src="img/logo.jpg" class="col-md-12">
                </div>
              </b-card-body>
            </b-card>

            <b-card no-body md="12" style="border: none;">
              <b-card-body class="p-4">
                <b-form @submit.prevent="setPass">
                  <h4 class="mb-5 text-center">Olvidé mi contraseña</h4>

                  <b-input-group class="px-5 pb-3 ">
                    <b-form-input type="password" class="form-control" placeholder="Contraseña" autocomplete="current-password" v-model="user.password"/>
                  </b-input-group>
                  <b-input-group class="px-5 pb-3 ">
                    <b-form-input type="password" class="form-control" placeholder="Confirmar contraseña"  v-model="confirm"/>
                  </b-input-group>

                  <b-row class="justify-content-center pt-2">
                      <b-button type="submit" variant="primary" class="px-5 btn btn-pill" :disabled="(confirm.length < 8) || (user.password != confirm)">Actualizar</b-button>
                  </b-row>
                  <div class="px-5 pt-4">
                    <i class="x"></i>
                    <span class="d-inline-flex">
                      <i :class="(user.password.length < 8) ? 'text-danger cui-circle-x' : 'text-success fa cui-circle-check '"></i>
                        <p :class="(user.password.length < 8) ? 'text-danger' : 'text-success'" class="pl-2 font-weight-bold">Compuesta por más de 8 caractéres</p>
                    </span>
                    <span class="d-inline-flex">
                      <i :class="(user.password != confirm || user.password.length < 8)  ? 'text-danger cui-circle-x' : 'text-success fa cui-circle-check '"></i>
                        <p :class="(user.password != confirm || user.password.length < 8) ? 'text-danger' : 'text-success'"  class="pl-2 font-weight-bold">Las contraseñas coinciden</p>
                    </span>
                    <span class="d-inline-flex">
                      <i :class="error == true ? 'text-danger cui-circle-x' : 'text-success fa cui-circle-check '"></i>
                      <p :class="error == true ? 'text-danger' : 'text-success'"  class="pl-2 font-weight-bold">Mayúscula, minúscula, número y simbolo</p>
                    </span>
                  </div>
                </b-form>
              </b-card-body>
            </b-card>

          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import VueNotifications from 'vue-notifications';

export default {
    name: 'SetPass',
    data: ()=> ({
        confirm: "",
        user:{
            password: "",
        },
        error: true,
    }),
    mounted(){
        
    },
    methods:{
        setPass(){
            let self = this
            axios.put('/login/reset', this.user)
            .then(function (response) {
              self.showSuccessMsg()
            })
            .catch(function (error) {
              //Completar con información reportada por el backend
              self.showErrorMsg({title:"Algo salió mal", message:"El correo no existe"})
            });
        },
        checkPassword(){
          var re = /^(?=.*\d)(?=.*[!@#$%^&*.])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
          return re.test(this.user.password);
        }

    },
    notifications: {
      showSuccessMsg: {
        type: VueNotifications.types.success,
        title: 'Petición correcta',
        message: 'Contraseña actualizada con éxito'
      },
      showErrorMsg: {
        type: VueNotifications.types.error,
        title: 'Algo salió mal',
        message: 'Ocurrió un error al realizar la acción'
      }
    },
    watch:{
      'user.password': function(){
        if(this.checkPassword()){
          this.error = false
        }else{
          this.error = true
        }
      }
    }
}
</script>
<style scoped>
input {
  border: 0;
  outline: 0;
  background: transparent;
  border-bottom: 1px solid lightgrey;
}
p{
  margin-bottom: 1px;
}
</style>
